import {Component, Input, OnInit} from '@angular/core';
import {DeviceFullDTO} from 'src/app/services/api/api';
import {TranslateService} from '@ngx-translate/core';
import {DeviceService} from '../../../services/device/deviceService';

@Component({
  selector: '[sb-device-online-status]',
  templateUrl: './sb-device-online-status.component.html',
  styleUrls: ['./sb-device-online-status.component.scss'],
  standalone: false,
})
export class SbDeviceOnlineStatusComponent implements OnInit {
  _device: DeviceFullDTO;
  @Input() tooltipPlacement: string;

  @Input() set device(val: DeviceFullDTO) {
    this._device = val;
    this.initFields();
  }

  get device(): DeviceFullDTO {
    return this._device;
  }

  tooltip: string;
  text: string;
  color: string;

  constructor(
    public translate: TranslateService,
    public deviceService: DeviceService
  ) {}

  ngOnInit(): void {
    this.initFields();
    this.translate.onDefaultLangChange.subscribe(() => {
      this.initFields();
    });
  }

  private initFields() {
    this.tooltip = this.deviceService.lastOnlineTitle(this.device);
    this.text = this.deviceService.lastOnline(this.device);
    this.color = this.deviceService.iconColor(this.device);
  }
}
